export default "__VITE_ASSET__DEOrcEt8__"